<template>
  <TariffNotificationModal
      ref="modalRef"
      title="Мы запустили новую систему тарифов — теперь вы сами выбираете нужные функции"
      image-url="/assets/images/tariff/picture-new-tariff.png"
      @button-click="onConfirm"
      @hidden="emit('hidden')"
  >

    <template #default>
        <template v-if="!isTrialExpired">
            <p class="release-announcement-modal__text mb-3">
                Все возможности платформы доступны бесплатно до {{ formattedDate }}
            </p>
            <p class="release-announcement-modal__text mb-3">
                После — можно подключить только нужные вам функции. Узнайте подробнее и выберите подходящий вариант.
            </p>
        </template>
        <template v-else>
            <p class="release-announcement-modal__text mb-3">
                Бесплатный период завершён. Теперь вы можете подключить только нужные вам функции.
            </p>
            <p class="release-announcement-modal__text mb-3">
                Узнайте подробнее и выберите подходящий вариант.
            </p>
        </template>
    </template>
  </TariffNotificationModal>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import TariffNotificationModal from '../../TariffNotificationModal.vue';

const props = defineProps<{
    freeAccessUntil: string;
    isTrialExpired: boolean;
}>();

const emit = defineEmits<{
    (e: 'hidden'): void;
    (e: 'confirm'): void;
}>();

const formattedDate = computed(() => {
    const date = new Date(props.freeAccessUntil);
    return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
});

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();
function onConfirm() {
    emit('confirm');
    window.location.href = '/PaidFeatures';
}
function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

defineExpose({
    show: showModal,
    hide: hideModal,
});

</script>

<style lang="scss" scoped>
.release-announcement-modal__image {
    width: 267px;
    height: 203px;
    object-fit: cover;
    display: block;

    @media (max-width: 767.98px) {
        width: 165px;
        height: 126px;
        margin: 0 auto 10px;
    }
}

.release-announcement-modal__text {
    font-size: 14px;
}

.release-announcement-modal__footer {
    margin-top: 1rem;
    text-align: right;

    @media (max-width: 767.98px) {
        text-align: center;
    }
}
</style>
